import { render, staticRenderFns } from "./CallbackPushRecovery.vue?vue&type=template&id=f46dd2b6&scoped=true&"
import script from "./CallbackPushRecovery.vue?vue&type=script&lang=ts&"
export * from "./CallbackPushRecovery.vue?vue&type=script&lang=ts&"
import style0 from "./CallbackPushRecovery.vue?vue&type=style&index=0&id=f46dd2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46dd2b6",
  null
  
)

export default component.exports